import { render, staticRenderFns } from "./BuyNotice.vue?vue&type=template&id=0fdf42d0&scoped=true&"
import script from "./BuyNotice.vue?vue&type=script&lang=js&"
export * from "./BuyNotice.vue?vue&type=script&lang=js&"
import style0 from "./BuyNotice.vue?vue&type=style&index=0&id=0fdf42d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fdf42d0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\other\\DaMou-Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0fdf42d0')) {
      api.createRecord('0fdf42d0', component.options)
    } else {
      api.reload('0fdf42d0', component.options)
    }
    module.hot.accept("./BuyNotice.vue?vue&type=template&id=0fdf42d0&scoped=true&", function () {
      api.rerender('0fdf42d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/運勢書2024/BuyNotice.vue"
export default component.exports